<template>
    <b-modal :id="id" body-class="p-1" size="lg" title-class="w-100" :title="'Cari Seç'" no-close-on-esc no-close-on-backdrop>
        <template #modal-title>
            <div class="d-flex w-100 align-items-center">
                <span>Cari Seç</span>
                <div v-if="!getting" class="btn btn-outline-secondary btn-xs ml-auto fs-075" v-on:click="refetch">Yeniden Çek</div>
            </div>
        </template>
        <div v-if="getting" class="text-center p-1">
            <b-spinner small ></b-spinner>
            Bu işlem biraz uzun sürebilir...
        </div>
        <div class="d-flex g-50" v-if="!getting">
            <input ref="searchInput" v-model="searchCode" class="form-control mb-1" placeholder="Cari Kodu Ara..."/>
            <input ref="searchInput" v-model="search" class="form-control mb-1" placeholder="Cari Ara..."/>
        </div>
        <template v-if="!getting">
            <RecycleScroller class="scroller" :items="c_list" :item-size="56" key-field="CariKod" v-slot="{ item }">
                <div class="item">
                    <b-form-checkbox :checked="code == item.CariKod" v-on:change="$e => $emit('pick',$e ? item : null)" :id="item.CariKod"></b-form-checkbox>
                    <label :for="item.CariKod" class="overflow-hidden text-nowrap item-name"> 
                        <h6>{{ item.CariKod }}</h6>
                        <small class="text-truncate d-block">{{ item.CariIsim || 'İsim Yok' }}</small>
                    </label>
                </div>
            </RecycleScroller>
        </template>
        <template #modal-footer>
            <button class="btn btn-primary" v-on:click="done">Tamam</button>
        </template>
    </b-modal>
</template>

<script>
import NetsisOperationsApi from '@/api/netsis-operations'
import { BSpinner, BFormCheckbox } from 'bootstrap-vue'
import { loadData, saveData, clearData } from '@/utilities/data'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import Additional from '@/utilities/additional'

export default {
    components:{
        BSpinner,
        RecycleScroller,
        BFormCheckbox
    },
    props:{
        id:{
            type:String,
            default:'cari-picker'
        },
        code:{
            type:String,
            default:null
        }
    },
    data(){
        return {
            getting:false,
            cari:null,
            cariList: null,
            search:'',
            searchCode:''
        }
    },
    async mounted(){
        this.getting = true
        const cached = await loadData('cari-list')
        if(cached){
            this.cariList = cached
            this.getting = false
        }else{
            this.getCariList()
        }
    },
    methods:{
        refetch(){
            this.$confirm('Yeniden çekmek istediğinize emin misiniz?','Netsis üzerindeki veriler çekilir. Bu işlem uzun sürebilir.').then(async (res) => {
                if(res){
                    await clearData('cari-list')
                    this.getCariList()
                }
            })
        },
        getCariList(){
            this.getting = true
            NetsisOperationsApi.GetAllCariList().then(async (res) => {
                await saveData('cari-list',res.data.Data)
                this.cariList = res.data.Data
                this.getting = false
            })
        },
        pick(){
            this.search = ''
            this.$showModal(this.id)
        },
        done(){
            this.$hideModal(this.id)
        }
    },
    computed:{
        c_list(){
            return (this.cariList || []).filter(s => 
                Additional.ToEng(s.CariIsim).toLowerCase().includes(Additional.ToEng(this.search).toLowerCase())
            ).filter(s => Additional.ToEng(s.CariKod).toLowerCase().includes(Additional.ToEng(this.searchCode).toLowerCase()))
        }
    }
}
</script>

<style scoped>
.scroller{
    height: 480px;
}
.item{
    height: 56px;
    overflow: hidden;
    display: flex;
    align-items: center;
}
.item-name{
    flex:1;
}
.fs-075{
    font-size: 0.75rem;
}
</style>